import { getPurchaseHistory } from "@/services/booking";

const state = {
  purchaseHistories: null,
};

const getters = {
  purchaseHistories: (state) => state.purchaseHistories,
};

const actions = {
  async getPurchaseHistory({ commit }) {
    try {
      const response = await getPurchaseHistory();
      commit("getPurchaseHistory", response.data);
    } catch (error) {
      console.log(error);
    }
  },
  resetPurchaseHistory({ commit }) {
    commit("resetPurchaseHistory", null)
  }
};

const mutations = {
  getPurchaseHistory: (state, data) => (state.purchaseHistories = data),
  resetPurchaseHistory: (state, data) => (state.purchaseHistories = data),
};

export default { state, getters, actions, mutations };
